<template>
  <v-dialog v-model="visibility" persistent max-width="432px" content-class="elevation-0 rounded-xl">
    <v-card>
      <v-card-title class="py-6">Preview Script</v-card-title>
      <v-card-text>{{ script }}</v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn small class="rounded-xl text-capitalize pa-4 confirm-button" color="red" height="36px" @click="$store.commit('RESET_PREVIEW_SCRIPT_DIALOG')"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PreviewScriptDialog',
  computed: {
    ...mapState(['previewScriptDialog']),
    visibility() {
      return this.previewScriptDialog.visibility
    },
    script() {
      return this.previewScriptDialog.script
    }
  }
}
</script>

<style scoped>
.confirm-button {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
}
</style>
